export default __webpack_public_path__ + "static/IMG_9255-64ba1081fde507d9342114cdd65a28cf.jpeg";